import module from 'empresas/module.js'

export const schema = {existe: 'boolean'}

export class EmpresasRfcExisteService {
  constructor ($http) {
    this.$http = $http
  }

  get (rfc) {
    return this.$http.get('/api/empresas/rfc_existe', {params: {rfc: rfc}, schema: schema})
  }
}

module.service('EmpresasRfcExiste', EmpresasRfcExisteService)



// WEBPACK FOOTER //
// ./src/empresas/services/EmpresasRfcExiste.js